import { useSelector } from 'react-redux';

import * as scenarioGridSelectors from '@makemydeal/dr-dash-store/selectors/scenarioGridSelectors';
import type { ScenarioGridCell } from '@makemydeal/dr-dash-store/types/scenarioGridTypes';

import { ScenarioRow } from './ScenarioRow';
import { SCENARIO_NOT_APPLICABLE_RENDERERS, SCENARIO_ROW_RENDERERS } from './scenarioRowRenderers';

export const NOT_APPLICABLE_VALUE = '—';

const renderCell = ({ rowKey, label, isApplicable }: ScenarioGridCell) => {
    const NotApplicableRow = SCENARIO_NOT_APPLICABLE_RENDERERS[rowKey];
    if (!isApplicable && NotApplicableRow) {
        return <NotApplicableRow key={rowKey} />;
    }
    if (!isApplicable) {
        return (
            <ScenarioRow key={rowKey} rowKey={rowKey} label={label}>
                <span aria-label="Not applicable" data-testid={`scenario-row-${rowKey}-not-applicable`}>
                    {NOT_APPLICABLE_VALUE}
                </span>
            </ScenarioRow>
        );
    }
    const Field = SCENARIO_ROW_RENDERERS[rowKey];
    return <Field key={rowKey} />;
};

export const ScenarioRows = () => {
    const cells = useSelector(scenarioGridSelectors.getScenarioGridCells);

    return <>{cells.map(renderCell)}</>;
};
